export default "__VITE_ASSET__D3RJJ7kX__"